module.exports = __webpack_public_path__ + "static/img/code_phone.a9610d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/code_phone.png
// module id = mb0u
// module chunks = 9